// Generated by scripts/write-tri-anger-replay-fixtures.ts.
// Do not edit by hand.

import type { GameState } from "@cloudnest/tri-anger-engine";
import type { TriAngerReplayEventType } from "./event-adapter";

export interface TriAngerReplayFixtureEvent {
  readonly sequenceNumber: number;
  readonly eventType: TriAngerReplayEventType;
  readonly userId?: string;
  readonly payload: Record<string, unknown>;
}

export interface TriAngerReplayFixture {
  readonly schemaVersion: 1;
  readonly gameType: "tri-anger";
  readonly scenario: string;
  readonly source: "generated" | "inmemory" | "staging" | "prod";
  readonly capturedAt: string;
  readonly players: readonly {
    readonly id: string;
    readonly name: string;
    readonly role: "host" | "player" | "observer" | "system" | string;
  }[];
  readonly events: readonly TriAngerReplayFixtureEvent[];
  readonly notes: readonly string[];
}

export const TRI_ANGER_REPLAY_FIXTURES: Readonly<
  Record<string, TriAngerReplayFixture>
> = {
  "simple-2p-live": {
    schemaVersion: 1,
    gameType: "tri-anger",
    scenario: "simple-2p-live",
    source: "generated",
    capturedAt: "2026-06-09T00:00:00.000Z",
    players: [
      {
        id: "p1",
        name: "Ari",
        role: "host",
      },
      {
        id: "p2",
        name: "Bo",
        role: "player",
      },
      {
        id: "observer-1",
        name: "Observer",
        role: "observer",
      },
    ],
    events: [
      {
        sequenceNumber: 1,
        eventType: "init",
        userId: "p1",
        payload: {
          state: {
            gameId: "simple-2p-live",
            version: "tri-anger-0.1.0",
            board: [
              {
                position: {
                  x: 0,
                  y: 0,
                },
                kind: "multi",
                income: 5,
              },
              {
                position: {
                  x: 1,
                  y: 0,
                },
                kind: "home",
                income: 5,
                homeOwnerId: "p1",
              },
              {
                position: {
                  x: 2,
                  y: 0,
                },
                kind: "empty",
                income: 0,
              },
              {
                position: {
                  x: 3,
                  y: 0,
                },
                kind: "capture",
                income: 1,
              },
              {
                position: {
                  x: 4,
                  y: 0,
                },
                kind: "empty",
                income: 0,
              },
              {
                position: {
                  x: 5,
                  y: 0,
                },
                kind: "capture",
                income: 2,
              },
              {
                position: {
                  x: 0,
                  y: 1,
                },
                kind: "home",
                income: 5,
                homeOwnerId: "p1",
              },
              {
                position: {
                  x: 1,
                  y: 1,
                },
                kind: "home",
                income: 5,
                homeOwnerId: "p1",
              },
              {
                position: {
                  x: 2,
                  y: 1,
                },
                kind: "empty",
                income: 0,
              },
              {
                position: {
                  x: 3,
                  y: 1,
                },
                kind: "empty",
                income: 0,
              },
              {
                position: {
                  x: 4,
                  y: 1,
                },
                kind: "capture",
                income: 0,
              },
              {
                position: {
                  x: 5,
                  y: 1,
                },
                kind: "empty",
                income: 0,
              },
              {
                position: {
                  x: 0,
                  y: 2,
                },
                kind: "empty",
                income: 0,
              },
              {
                position: {
                  x: 1,
                  y: 2,
                },
                kind: "empty",
                income: 0,
              },
              {
                position: {
                  x: 2,
                  y: 2,
                },
                kind: "capture",
                income: 3,
              },
              {
                position: {
                  x: 3,
                  y: 2,
                },
                kind: "blocked",
                income: 0,
              },
              {
                position: {
                  x: 4,
                  y: 2,
                },
                kind: "empty",
                income: 0,
              },
              {
                position: {
                  x: 5,
                  y: 2,
                },
                kind: "capture",
                income: 1,
              },
              {
                position: {
                  x: 0,
                  y: 3,
                },
                kind: "capture",
                income: 1,
              },
              {
                position: {
                  x: 1,
                  y: 3,
                },
                kind: "empty",
                income: 0,
              },
              {
                position: {
                  x: 2,
                  y: 3,
                },
                kind: "blocked",
                income: 0,
              },
              {
                position: {
                  x: 3,
                  y: 3,
                },
                kind: "capture",
                income: 3,
              },
              {
                position: {
                  x: 4,
                  y: 3,
                },
                kind: "empty",
                income: 0,
              },
              {
                position: {
                  x: 5,
                  y: 3,
                },
                kind: "empty",
                income: 0,
              },
              {
                position: {
                  x: 0,
                  y: 4,
                },
                kind: "empty",
                income: 0,
              },
              {
                position: {
                  x: 1,
                  y: 4,
                },
                kind: "capture",
                income: 0,
              },
              {
                position: {
                  x: 2,
                  y: 4,
                },
                kind: "empty",
                income: 0,
              },
              {
                position: {
                  x: 3,
                  y: 4,
                },
                kind: "empty",
                income: 0,
              },
              {
                position: {
                  x: 4,
                  y: 4,
                },
                kind: "home",
                income: 5,
                homeOwnerId: "p2",
              },
              {
                position: {
                  x: 5,
                  y: 4,
                },
                kind: "home",
                income: 5,
                homeOwnerId: "p2",
              },
              {
                position: {
                  x: 0,
                  y: 5,
                },
                kind: "capture",
                income: 2,
              },
              {
                position: {
                  x: 1,
                  y: 5,
                },
                kind: "empty",
                income: 0,
              },
              {
                position: {
                  x: 2,
                  y: 5,
                },
                kind: "capture",
                income: 1,
              },
              {
                position: {
                  x: 3,
                  y: 5,
                },
                kind: "empty",
                income: 0,
              },
              {
                position: {
                  x: 4,
                  y: 5,
                },
                kind: "home",
                income: 5,
                homeOwnerId: "p2",
              },
              {
                position: {
                  x: 5,
                  y: 5,
                },
                kind: "multi",
                income: 5,
              },
            ],
            players: [
              {
                id: "p1",
                name: "Ari",
                faction: "ECSU",
                gold: 5,
                techCoins: 0,
                unitDeck: ["TURTLE", "WORKER", "TALDI", "INVOLVE", "BOMBARD"],
                techDeck: [
                  "ECSU_GRASSROOTS",
                  "ECSU_BLOOD_CURTAIN",
                  "ECSU_THORNY_ROAD",
                  "ECSU_FOR_FEDERATION",
                  "ECSU_MONGMONG",
                  "ECSU_DARK_TOWER",
                ],
                ownedTech: [],
              },
              {
                id: "p2",
                name: "Bo",
                faction: "GO",
                gold: 8,
                techCoins: 0,
                unitDeck: ["DEFY", "SONIC", "LATENCY", "BANDIT", "PRIVE"],
                techDeck: [
                  "GO_MAINTENANCE",
                  "GO_REVOLUTION_FROM_BELOW",
                  "GO_FORCE_EQUALS_MA",
                  "GO_UNFINISHED_REVOLUTION",
                  "GO_DARK_PATH",
                  "GO_HEAVY_ARMOR",
                ],
                ownedTech: [],
              },
            ],
            currentPlayerId: "p1",
            turn: 1,
            phase: "MOVE",
            units: [],
            constructionByCell: {},
            controlByCell: {
              "1,0": "p1",
              "0,1": "p1",
              "1,1": "p1",
              "4,4": "p2",
              "5,4": "p2",
              "4,5": "p2",
            },
            turnFlags: {
              boughtTechCoinPlayerIds: [],
            },
            combatLog: [],
            log: [
              {
                turn: 1,
                phase: "MOVE",
                message: "Tri-Anger game initialized.",
              },
            ],
            nextUnitSequence: 1,
          },
        },
      },
      {
        sequenceNumber: 2,
        eventType: "EndPhase",
        userId: "p1",
        payload: {
          type: "EndPhase",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 3,
        eventType: "ProduceUnit",
        userId: "p1",
        payload: {
          type: "ProduceUnit",
          playerId: "p1",
          unitTypeId: "WORKER",
        },
      },
      {
        sequenceNumber: 4,
        eventType: "EndPhase",
        userId: "p1",
        payload: {
          type: "EndPhase",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 5,
        eventType: "EndPhase",
        userId: "p1",
        payload: {
          type: "EndPhase",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 6,
        eventType: "EndPhase",
        userId: "p1",
        payload: {
          type: "EndPhase",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 7,
        eventType: "EndPhase",
        userId: "p1",
        payload: {
          type: "EndPhase",
          playerId: "p1",
        },
      },
      {
        sequenceNumber: 8,
        eventType: "Surrender",
        userId: "p2",
        payload: {
          type: "Surrender",
          playerId: "p2",
        },
      },
    ],
    notes: [
      "Tri-Anger is public-information in this v2 slice; replay renders canonical state directly.",
      "Fixture covers init, phase progression, first production, waiting/read-only state, and terminal surrender.",
      "Final state: phase GAME_OVER, winner p1, victory surrender.",
      "Observer/read-only policy: observers receive the same public canonical state with disabled controls.",
    ],
  },
} as const;

export function getTriAngerReplayInitialState(
  scenario: string,
): GameState | null {
  const fixture = TRI_ANGER_REPLAY_FIXTURES[scenario];
  const init = fixture?.events.find((event) => event.eventType === "init");
  return (init?.payload.state as GameState | undefined) ?? null;
}
